import { useUserFeature } from 'src/hooks';

export const useSpecialtyQueueAccess = (): boolean => useUserFeature('specialty_income_review');
